import styled from 'styled-components';
import CustomScrollbar from 'components/CustomScrollbar';
import { mediaBreakpointDown, mediaBreakpointUp } from 'styles/grid';

export const Body = styled(CustomScrollbar)`
  ${mediaBreakpointDown.sm} {
    padding: 8px 12px;
  }

  overflow: auto;
  flex: 1;
  padding: 16px 32px;
`;

export const ProgressIndicatorContainer = styled.div`
  ${mediaBreakpointUp.md} {
    padding: 0 32px;
  }
`;

export const LoadingWrapper = styled.div`
  margin: auto;
`;

export const TrackingDetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const SearchFormBox = styled.div`
  ${mediaBreakpointUp.md} {
    width: 260px;
  }

  flex: 1;
  display: flex;
  align-items: center;
  width: 210px;
  margin: 0 auto;
  text-align: center;
`;
